import { Box, Typography, Button, CardMedia } from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { ComponentProps } from "@arelia-types/widget";
import { DataGrid } from "@arelia-components/ui-atoms/data-grid";
import { useQuery } from "react-query";
import { http } from "src/api/http";
import { CampaignSms } from "./models";
import { formatDate } from "@arelia-utils/helpers/dates";
import { useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import noDataImg from "@arelia-assets/no-data.svg";

export function CampaignSmsContainer({ config }: ComponentProps) {
  const navigate = useNavigate();
  const { data = [], isLoading, isError } = useQuery<CampaignSms[]>({
    queryKey: ["campaign-sms-count"],
    queryFn: () => http('/api/my-fans/campaign/sms-count')
  });

  const columnConfig = [{
    field: "date",
    headerName: "Date",
    width: "200px",
    formatter: (params: any) => params.value ? formatDate(new Date(params.value), "MM/dd/yyyy") : ''
  }, {
    field: "campaign",
    headerName: "Campaign name",
    width: "500px",
    renderer: (params: any) => (
      <Typography
        variant="subtitle2"
        color="primary"
        sx={{ cursor: 'pointer' }}
        onClick={() => navigate(`${PATHS.CAMPAIGN_LIST}/${params.row.campaignId}`)}
      >
        {params.value}
      </Typography>
    )
  }, {
    field: "delivered",
    headerName: "Delivered",
    width: "100px",
    formatter: (params: any) => params.value?.toString() || '0',
    align: "left" as const
  }, {
    field: "pending",
    headerName: "Pending",
    width: "100px",
    formatter: (params: any) => params.value?.toString() || '0',
    align: "left" as const
  }, {
    field: "status",
    headerName: "Status",
    width: "100px"
  }];

  const totalMessages = data.reduce((sum, item) => sum + item.delivered + item.pending, 0);
  const hasData = data && data.length > 0;

  return (
    <WidgetCard
      widgetId="CAMPAIGN_SMS"
      title="campaign sms"
      disableFavorite={true}
      loading={isLoading}
      error={isError}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: 1, height: 1, overflow: 'hidden' }}>
        <Typography variant="h2">
          {totalMessages.toLocaleString()} Total Messages Sent
        </Typography>
        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          {hasData ? (
            <DataGrid
              columns={columnConfig}
              rows={data}
              sx={{ overflow: 'auto', maxHeight: '100%', flex: 1 }}
            />
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              <CardMedia
                sx={{ backgroundSize: "contain", height: 45, width: 70, mt: 1, mb: 2 }}
                image={noDataImg}
                title="No Data"
              />
              <Typography variant="subtitle1" color="secondary">
                No Data Found
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => navigate(PATHS.CAMPAIGN_LIST + "/new")}
                sx={{ mt: 2 }}
              >
                Create First Campaign
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </WidgetCard>
  );
}
